// extracted by mini-css-extract-plugin
export var acitonButtons = "_3d-0";
export var additionalIcon = "_3d-f";
export var block = "_3d-1";
export var blockContent = "_3d-7";
export var blockDescription = "_3d-8";
export var blockIcon = "_3d-9";
export var blockTitle = "_3d-6";
export var border = "_3d-a";
export var center = "_3d-l";
export var edge = "_3d-b";
export var edgeLabel = "_3d-c";
export var edgePath = "_3d-d";
export var error = "_3d-e";
export var flowchart = "_3d-g";
export var flowchartContent = "_3d-h";
export var highlighted = "_3d-3";
export var hover = "_3d-4";
export var icon = "_3d-i";
export var left = "_3d-m";
export var navButton = "_3d-j";
export var navButtons = "_3d-k";
export var right = "_3d-n";
export var selected = "_3d-2";
export var small = "_3d-5";